import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateY(-120%) translateX(-50%) scale(0.9);
    opacity: 0;
  }
  to {
    transform: translateY(0) translateX(-50%) scale(1);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0) translateX(-50%) scale(1);
    opacity: 1;
  }
  to {
    transform: translateY(-120%) translateX(-50%) scale(0.9);
    opacity: 0;
  }
`;

const ToastContainer = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
  animation: ${props => props.$isVisible ? slideIn : slideOut} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  pointer-events: none;

  @media (max-width: 768px) {
    top: 10px;
    padding: 10px 20px;
    font-size: 13px;
  }
`;

const Icon = styled.span`
  font-size: 18px;
`;

interface ToastProps {
  message: string;
  duration?: number;
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ message, duration = 4000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 500); // Attendre la fin de l'animation (0.5s)
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <ToastContainer $isVisible={isVisible}>
      <Icon>🎨</Icon>
      <span>{message}</span>
    </ToastContainer>
  );
};

export default Toast;
